import {NavigateFunction} from "react-router-dom";
import {savaquanFetch, savaquanFetchJson} from "./http.service";
import {CompanySettingDto, EstimateFollowUpSchedule, InvoiceDueDateSetting} from "../dtos/company-settings.dto";

const baseUrl = `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/company-settings/estimate-follow-up-schedule`;

/** SQ-563: the company's estimate follow-up schedule. No schedule saved yet (204) is null, as Android treats it. */
export async function getEstimateFollowUpSchedule(navigate: NavigateFunction): Promise<CompanySettingDto<EstimateFollowUpSchedule> | null> {
  const response = await savaquanFetch(baseUrl, {navigate});
  return response.status === 204 ? null : await response.json() as CompanySettingDto<EstimateFollowUpSchedule>;
}

export async function saveEstimateFollowUpSchedule(navigate: NavigateFunction, schedule: EstimateFollowUpSchedule): Promise<CompanySettingDto<EstimateFollowUpSchedule>> {
  return savaquanFetchJson<CompanySettingDto<EstimateFollowUpSchedule>>(baseUrl, {
    navigate,
    method: 'PUT',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(schedule),
  });
}

// SQ-687 / SQ-688: the invoice due date and the follow-ups after it. Through
// savaquanFetchJson so the page can tell a 403 (no invoices.manage_due_dates)
// and show the server's reason for a refused save.
export async function getInvoiceDueDate(navigate: NavigateFunction): Promise<InvoiceDueDateSetting> {
  return await savaquanFetchJson<InvoiceDueDateSetting>(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/company-settings/invoice-due-date`,
    {navigate});
}

export async function saveInvoiceDueDate(navigate: NavigateFunction, setting: InvoiceDueDateSetting): Promise<InvoiceDueDateSetting> {
  return await savaquanFetchJson<InvoiceDueDateSetting>(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/company-settings/invoice-due-date`,
    {
      navigate,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(setting),
    });
}
